import React from "react";
import ButtonLoader from "./ButtonLoader";

const CustomButton = ({
  text,
  width,
  height,
  weight,
  size,
  color,
  textColor,
  padding, // new padding prop
  icon,
  onClick,
  borderRadius,
  border,
  disabled,
  loader,
  fontSize,
  classes
}) => {
  return (
    <button
      onClick={onClick}
      type="button"
      disabled={disabled}
      className={`flex items-center justify-center gap-1 rounded-md ${border} ${width} ${height} ${weight} ${size} ${color} ${textColor} ${borderRadius} ${padding} ${classes}`}
    >
      <span
        className={fontSize ? fontSize : "text-[14px]"}
        style={{ fontWeight: "600" }}
      >
        {loader ? <ButtonLoader /> : text}
      </span>
      {icon && <span className="flex-shrink-0">{icon}</span>}
    </button>
  );
};

export default CustomButton;
